import { render } from "./Lists.vue?vue&type=template&id=32e98fb3&scoped=true"
import script from "./Lists.vue?vue&type=script&lang=js"
export * from "./Lists.vue?vue&type=script&lang=js"

import "./Lists.vue?vue&type=style&index=0&id=32e98fb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e98fb3"]])

export default __exports__